import * as d3 from 'd3-selection'
import { axisLeft } from 'd3-axis'

const yAxisLabelHeight = 12

export default function (selection) {
  selection.each(function (d) {
    let scale = d.scale.copy().nice()
      , totalTicks = Math.max(Math.floor(Math.abs(scale.range()[0] / yAxisLabelHeight)), 2)
      , axis = axisLeft(scale)
                .ticks(totalTicks)
                .tickSize(-10)
                .tickFormat(d.formatter)
      , container = d3.select(this)
                      .selectAll('g.axis')
                      .data([d])
                      .enter()
                      .append('g')
                        .attr('class', 'axis axis-y')
                        .merge(d3.select(this).selectAll('g.axis'))
                        .raise()

    let ticks = container.call(axis)
                         .selectAll('.tick')
                         .classed('minor', false)

    ticks.data(scale.ticks(totalTicks / 3), d => d)
         .exit()
         .classed('minor', ticks.size() > 4)

    container.selectAll('.tick')
             .filter((d, i, all) => {
               return i == 0 || i == all.length - 1
             })
             .classed('minor', false)

    container.selectAll('.domain').remove()
  })

}
